<template>
  <RevCard class="mb-16 flex-1 p-24 md:mb-0 md:mt-16">
    <h2 class="heading-2 mb-8">
      {{ i18n(translations.mailbookTitle) }}
    </h2>
    <div class="text-static-default-low body-1 mb-20">
      {{ i18n(translations.description) }}
    </div>

    <AddContactForm
      class="mb-32"
      :contact-types="metadata?.contactTypes || []"
      @contact-added="refreshMailbook"
    />

    <RevLoadingScreen
      v-if="metadataStatus === 'pending' || mailbookStatus === 'pending'"
      class="my-96"
      :text="i18n(translations.loadingText)"
    />

    <template v-else>
      <MailbookWarning
        class="mb-32"
        :user-emails-not-in-mailbook="mailbook?.userEmailsNotInMailbook || []"
      />

      <ContactTypesList
        :current-contact-type="orderedContactTypes"
        :email-types="metadata?.emailTypes || []"
        @contact-deleted="refreshMailbook"
      />
    </template>
  </RevCard>
</template>

<script setup lang="ts">
import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import translations from './Mailbook.translations'
import AddContactForm from './components/AddContactForm.vue'
import ContactTypesList from './components/ContactTypesList.vue'
import MailbookWarning from './components/MailbookWarning.vue'

const $httpFetch = useHttpFetch()
const i18n = useI18n()

const { data: metadata, status: metadataStatus } = useAsyncData(() =>
  $httpFetch('/api/seller-experience/mailbook/metadata'),
)

const {
  data: mailbook,
  status: mailbookStatus,
  refresh: refreshMailbook,
} = useAsyncData(() => $httpFetch('/api/seller-experience/mailbook'))

const orderedContactTypes = computed(() => {
  const contactTypes = mailbook.value?.contactTypes || []

  return contactTypes.sort((a, b) => {
    const aHasEmailTypes = a.contacts.some(
      (contact: { emailTypes: unknown[] }) => contact.emailTypes.length > 0,
    )
    const bHasEmailTypes = b.contacts.some(
      (contact: { emailTypes: unknown[] }) => contact.emailTypes.length > 0,
    )

    if (aHasEmailTypes && !bHasEmailTypes) return -1
    if (!aHasEmailTypes && bHasEmailTypes) return 1

    return a.type.label.localeCompare(b.type.label)
  })
})
</script>
